<template>
  <div class="kt-login-v2__container">
    <login-form v-if="page === AuthPage.LOGIN"/>
    <forgot-password-form v-else-if="page === AuthPage.FORGET_PASSWORD"/>
    <two-factor-authentication v-else-if="page === AuthPage.TWO_FACTOR_AUTH"/>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { AuthPage, type MaintenanceNotification, useAuthStore } from '@/stores/auth'
import LoginForm from '@/auth/components/LoginForm.vue'
import ForgotPasswordForm from '@/auth/components/ForgotPasswordForm.vue'
import TwoFactorAuthentication from '@/auth/components/TwoFactorAuthentication.vue'

const props = defineProps<{
  maintenanceNotification: MaintenanceNotification | null
}>()

const {
  page,
  maintenanceNotification: maintenanceNotificationRef
} = storeToRefs(useAuthStore())

onBeforeMount(() => {
  maintenanceNotificationRef.value = props.maintenanceNotification

  // Remove the placeholder
  document.querySelector('#login-placeholder')?.remove()
})

onMounted(() => {
  // show the login page
  document.querySelector('#login-page')?.classList?.remove('d-none')
})
</script>
